import { defineEventHandler } from 'h3'

type EventCallback = (...args: any[]) => void

interface EventBus {
  on: (event: string, callback: EventCallback) => void
  off: (event: string, callback: EventCallback) => void
  emit: (event: string, ...args: any[]) => void
}

export const useEventBus = (): EventBus => {
  const eventMap = useState<Map<string, Set<EventCallback>>>('eventBus', () => new Map())

  const on = (event: string, callback: EventCallback): void => {
    if (!eventMap.value.has(event)) {
      eventMap.value.set(event, new Set())
    }
    eventMap.value.get(event)?.add(callback)
  }

  const off = (event: string, callback: EventCallback): void => {
    if (eventMap.value.has(event)) {
      eventMap.value.get(event)?.delete(callback)
    }
  }

  const emit = (event: string, ...args: any[]): void => {
    if (eventMap.value.has(event)) {
      eventMap.value.get(event)?.forEach(callback => callback(...args))
    }
  }

  return { on, off, emit }
}